// @ts-check
"use strict";

/**
 * Set a timeout that returns a promise that resolves when the timeout is reached.
 * @method setPromiseTimeout
 * @param {number} delay The delay in milliseconds
 * @returns {Promise<void>} A promise that resolves when the timeout is reached
 */
export const setPromiseTimeout = (delay) => {
  return new Promise((resolve) => setTimeout(resolve, delay));
};
